import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthHandler from "../AuthHandler"; 

const PrivateRoute = ({ allowedRoles }) => {
  const { isAuthenticated, role } = useSelector((state) => state.auth);
  const accountType = useSelector((state) =>
    state.formData?.accountType || state.buyerFormData?.accountType
  );

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const userRole = role || accountType;
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/" replace />;
  }

  return (
    <AuthHandler>
      <Outlet />
    </AuthHandler>
  );
};

export default PrivateRoute;

